export const loadBlockComponent = async (componentType: string, content: any) => {
    switch (componentType) {
        case 'accordion':
            return (await import('./Accordion')).default;
        case 'button':
            return (await import('./Button')).default;
        case 'countdown':
            return (await import('./Countdown')).default;
        case 'divider':
            return (await import('./Divider')).default;
        case 'embed':
            return (await import('./Embed')).default;
        case 'gridColumn':
            return (await import('./GridColumn')).default;
        case 'gridRow':
            return (await import('./GridRow')).default;
        case 'icon':
            return (await import('./Icon')).default;
        case 'headerButton':
            return (await import('./HeaderButton')).default;
        case 'headerImage':
            return (await import('./HeaderImage')).default;
        case 'media':
            if (content.srcType === 'image') {
                return (await import('./Image')).default;
            } else if (content.srcType === 'video') {
                return (await import('./Video')).default;
            }

            throw Error(`Unknown media src type ${content.srcType}`);
        case 'list':
            return (await import('./List')).default;
        case 'logos':
            return (await import('./Logos')).default;
        case 'paymentForm':
            return (await import('./PaymentForm')).default;
        case 'questionForm':
            return (await import('./FormQuestion')).default;
        case 'questionMedia':
            return (await import('./MediaQuestion')).default;
        case 'questionMultipleChoice':
            return (await import('./MultipleChoiceQuestion')).default;
        case 'questionText':
            return (await import('./TextQuestion')).default;
        case 'reviews':
            return (await import('./Reviews')).default;
        case 'sliderImage':
            return (await import('./ImageSlider')).default;
        case 'sliderTestimonial':
            return (await import('./TestimonialSlider')).default;
        case 'text':
            return (await import('./Text')).default;
        case 'videoQuestion':
            return (await import('./VideoQuestion')).default;
        case 'webinar':
            return (await import('./Webinar')).default;
        default:
            throw Error(`Unknown component type: ${componentType}`);
    }
};
